import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import(/* webpackChunkName: "home" */ '@/components/MainWrapper/Home')
const Welcome = () => import(/* webpackChunkName: "welcome" */ '@/components/PublicPages/Welcome')
// const NotImplemented = () => import(/* webpackChunkName: "" */ '@/components/shared/NotImplemented')
const GroupManagement = () => import(/* webpackChunkName: "groupManagment" */ '@/components/GroupManagement/GroupManagement')
const Invitations = () => import(/* webpackChunkName: "invitations" */ '@/components/GroupManagement/Invitations')
const Members = () => import(/* webpackChunkName: "members" */ '@/components/GroupManagement/Members')
const Profile = () => import(/* webpackChunkName: "profile" */ '@/components/Profile/Profile')
const Files = () => import(/* webpackChunkName: "files" */ '@/components/Files/Files')
const FastAnswers = () => import(/* webpackChunkName: "fastAnswers" */ '@/components/FastAnswers/FastAnswers')
const Polls = () => import(/* webpackChunkName: "polls" */ '@/components/Polls/Polls')
const News = () => import(/* webpackChunkName: "news" */ '@/components/News/News')
const GroupPages = () => import(/* webpackChunkName: "groupPages" */ '@/components/GroupPages/GroupPages')
const Chat = () => import(/* webpackChunkName: "chat" */ '@/components/Chat/Chat')
const ImproveYourExperience = () => import(/* webpackChunkName: "chat" */ '@/components/ImproveYourExperience/ImproveYourExperience')

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'active',
  // mode: 'history',
  routes: [
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/connection',
      name: 'NeedConnection',
      component: Welcome
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      children: [
        {
          path: 'events/:groupId?',
          alias: '',
          name: 'Events',
          component: require('@/components/Events/Events'),
          meta: {
            needConnected: true
          },
          props: (route) => {
            return {
              groupId: route.params.groupId ? parseInt(route.params.groupId) : null
            }
          }
        },
        {
          path: '/improveYourExperience',
          name: 'ImproveYourExperience',
          component: ImproveYourExperience,
          meta: {
            needConnected: true
          }
        },
        {
          path: '/administration',
          name: 'Administration',
          component: require('@/components/Administration/Administration'),
          meta: {
            needConnected: true
          }
        },
        {
          path: 'fast',
          name: 'FastAnswers',
          component: FastAnswers,
          meta: {
            needConnected: true
          }
        },
        {
          path: 'invitations',
          name: 'Invitations',
          component: Invitations,
          meta: {
            needConnected: true
          }
        },
        {
          path: 'news/:groupId?',
          name: 'News',
          component: News,
          meta: {
            needConnected: true
          }
        },
        {
          path: 'conversations/:groupId?',
          name: 'Conversations',
          component: require('@/components/Conversations/Conversations'),
          meta: {
            needConnected: true
          },
          props: (route) => {
            return {
              groupId: (route.params.groupId ? parseInt(route.params.groupId) : null)
            }
          }
        },
        {
          path: 'cal/yes/:eventId/:userId/:registerKey',
          component: require('@/components/Events/ExternalAnswer'),
          props (route) {
            return {
              answer: 'Yes',
              registerKey: route.params.registerKey,
              userId: parseInt(route.params.userId),
              eventId: parseInt(route.params.eventId)
            }
          }
        },
        {
          path: 'cal/no/:eventId/:userId/:registerKey',
          component: require('@/components/Events/ExternalAnswer'),
          props (route) {
            return {
              answer: 'No',
              registerKey: route.params.registerKey,
              userId: parseInt(route.params.userId),
              eventId: parseInt(route.params.eventId)
            }
          }
        },
        {
          path: 'mail/event/:groupId/:eventId',
          redirect (to) {
            return {
              name: 'Events',
              params: {
                groupId: to.params.groupId
              },
              query: {
                m: 'shared',
                k: 'event',
                i: to.params.eventId
              }
            }
          }
        },
        {
          path: 'mail/conv/:groupId/:convId',
          redirect (to) {
            return {
              name: 'Conversations',
              params: {
                groupId: to.params.groupId
              },
              query: {
                m: 'shared',
                k: 'conversation',
                i: to.params.convId
              }
            }
          }
        },
        {
          path: 'mail/space/:groupId',
          redirect (to) {
            return {
              name: 'Nodes',
              params: {
                type: 'group',
                id: to.params.groupId
              },
              query: {
                m: 'account',
                i: to.params.groupId
              }
            }
          }
        },
        {
          path: 'members/:groupId?',
          name: 'Members',
          component: Members,
          meta: {
            needConnected: true
          },
          props: (route) => {
            return {
              groupId: route.params.groupId ? parseInt(route.params.groupId) : null
            }
          }
        },
        {
          path: 'groupManagement/:groupId',
          name: 'GroupManagement',
          component: GroupManagement,
          meta: {
            needConnected: true
          },
          props: (route) => {
            return {
              groupId: parseInt(route.params.groupId)
            }
          }
        },
        {
          path: 'nodes/:type?/:id?',
          name: 'Nodes',
          component: Files,
          meta: {
            needConnected: true
          }
        },
        {
          path: 'polls/:groupId?',
          name: 'Polls',
          component: Polls,
          meta: {
            needConnected: true
          },
          props: (route) => {
            return {
              groupId: route.params.groupId ? parseInt(route.params.groupId) : null
            }
          }
        },
        {
          path: 'groupPage/:groupId?',
          name: 'GroupPage',
          component: GroupPages,
          meta: {
            needConnected: false
          }
        },
        {
          path: 'profile/:openTab?',
          name: 'Profile',
          component: Profile,
          meta: {
            needConnected: true
          },
          props: true
        },
        {
          path: 'chat',
          name: 'Chat',
          component: Chat,
          meta: {
            needConnected: true
          }
        },
        {
          path: '/forgot/:userId/:passwordToken',
          name: 'RecoverPassword',
          component: require('@/components/RecoverPassword/RecoverPassword'),
          props: true
        },
        {
          path: '/invit/:userId/:gId/:token',
          name: 'NewInvitation',
          component: Invitations,
          props: true
        },
        {
          path: '/join/:gId/:privateKey',
          name: 'JoinGroup',
          redirect (to) {
            return {
              name: 'GroupPage',
              params: {
                groupId: to.params.gId
              },
              query: {
                privateKey: to.params.privateKey
              }
            }
          }
        },
        // must be the last !
        {
          path: '*',
          component: GroupPages,
          name: 'GroupPageByUrl'
        }
      ]
    }
  ]
})

router.afterEach((to, from) => {
  window.gtag && window.gtag('config', 'UA-38351047-1', {
    'page_title': to.name,
    'page_path': to.fullPath
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js